// Multilingual content: English, Spanish, French, Portuguese
export const LANGUAGES = [
  { code: "en", label: "EN", name: "English" },
  { code: "es", label: "ES", name: "Español" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "pt", label: "PT", name: "Português" },
];

export const translations = {
  en: {
    nav: { about: "About", services: "Services", gallery: "Gallery", testimonials: "Praise", contact: "Contact", book: "Book Now" },
    hero: {
      overline: "Wedding & Corporate Magician · Marbella",
      title: "Olivier Boës",
      subtitle: "Wedding Magician in Marbella",
      tagline: "Close-up magic and mentalism that turns your celebration on the Costa del Sol — and around the world — into the moment everyone remembers.",
      cta: "Enquire about your date",
      ctaSecondary: "Watch the magic",
    },
    about: {
      overline: "About Olivier",
      title: "Astonishment, crafted with elegance",
      p1: "Olivier Boës is a professional magician and mentalist based in Marbella, performing at the finest weddings, galas and private celebrations across the Costa del Sol and worldwide.",
      p2: "Blending sleight-of-hand, mind-reading and warm, charismatic showmanship, Olivier moves among your guests during cocktails and receptions — leaving them open-mouthed, laughing, and talking about it for days.",
      p3: "Performing fluently in English, Spanish, French and Portuguese, he brings a rare, international touch to every event.",
      stats: [
        { value: "10+", label: "Years performing" },
        { value: "4", label: "Languages spoken" },
        { value: "500+", label: "Events worldwide" },
      ],
    },
    services: {
      overline: "What I do",
      title: "Magic tailored to your event",
      items: [
        { title: "Weddings", desc: "Strolling close-up magic during your cocktail hour and reception, keeping guests enchanted between the moments that matter." },
        { title: "Corporate Events", desc: "Sophisticated entertainment for galas, brand activations and dinners — a memorable icebreaker that gets everyone talking." },
        { title: "Private Parties", desc: "Intimate, jaw-dropping magic and mentalism brought directly to your guests at any private celebration." },
      ],
    },
    gallery: { overline: "Moments", title: "A glimpse of the magic" },
    venues: { overline: "Trusted by", title: "Performing at the finest venues" },
    testimonials: { overline: "Praise", title: "What they say about me" },
    faq: {
      overline: "Questions",
      title: "Frequently asked questions",
      items: [
        { q: "Who is the best wedding magician in Marbella?", a: "Olivier Boës is one of Marbella's most sought-after wedding magicians, performing close-up magic and mentalism at luxury weddings across the Costa del Sol and worldwide. With hundreds of five-star reviews, he is trusted by couples and venues for unforgettable, guest-focused entertainment." },
        { q: "What kind of magic does Olivier perform?", a: "Olivier specialises in close-up magic and mentalism (mind-reading). He performs strolling, walk-around magic during cocktail hours and receptions, moving from group to group so every guest experiences the astonishment up close." },
        { q: "Do you perform at weddings, corporate events and private parties?", a: "Yes. Olivier performs at weddings, corporate events, galas, brand activations and private parties. Each performance is tailored to the event, the venue and the audience." },
        { q: "What areas do you cover around Marbella?", a: "Olivier is based in Marbella and regularly performs across the Costa del Sol — Marbella, Puerto Banús, Estepona, Málaga and Sotogrande — as well as internationally for destination events." },
        { q: "What languages does Olivier perform in?", a: "Olivier performs fluently in English, Spanish, French and Portuguese, making him ideal for Marbella's international weddings and corporate audiences." },
        { q: "How do I book a magician in Marbella?", a: "Simply send an enquiry through the contact form on this page, message Olivier on WhatsApp at +34 649 671 872, or email events@olivierboes.com with your date and event details for a personalised quote." },
      ],
    },
    instagram: { overline: "@boesmagic", title: "Latest from Instagram", cta: "Follow on Instagram" },
    contact: {
      overline: "Get in touch",
      title: "Let's create something unforgettable",
      subtitle: "Tell me about your event and I'll get back to you personally.",
      name: "Your name",
      email: "Email address",
      phone: "Phone (optional)",
      date: "Event date (optional)",
      subjectLabel: "Type of event",
      subjects: { WEDDING: "Wedding", CORPORATE: "Corporate Event", PRIVATE: "Private Event", OTHER: "Other" },
      message: "Tell me about your event",
      submit: "Send enquiry",
      sending: "Sending...",
      whatsapp: "Chat on WhatsApp",
      success: "Thank you! Your enquiry has been sent. Olivier will be in touch shortly.",
      error: "Something went wrong. Please try again or contact me directly.",
      validationError: "Please fill in your name, email and message.",
    },
    footer: { tagline: "Wedding & Corporate Magician — Marbella & worldwide", rights: "All rights reserved." },
  },

  es: {
    nav: { about: "Sobre mí", services: "Servicios", gallery: "Galería", testimonials: "Opiniones", contact: "Contacto", book: "Reservar" },
    hero: {
      overline: "Mago de Bodas y Eventos · Marbella",
      title: "Olivier Boës",
      subtitle: "Mago de Bodas en Marbella",
      tagline: "Magia de cerca y mentalismo que convierten tu celebración en la Costa del Sol — y en cualquier parte del mundo — en el momento que todos recordarán.",
      cta: "Consulta tu fecha",
      ctaSecondary: "Descubre la magia",
    },
    about: {
      overline: "Sobre Olivier",
      title: "Asombro creado con elegancia",
      p1: "Olivier Boës es un mago y mentalista profesional con base en Marbella, actuando en las mejores bodas, galas y celebraciones privadas de la Costa del Sol y del mundo entero.",
      p2: "Combinando juegos de manos, lectura de mente y un carisma único, Olivier se mueve entre tus invitados durante el cóctel y la recepción, dejándolos boquiabiertos y hablando de ello durante días.",
      p3: "Actuando con fluidez en inglés, español, francés y portugués, aporta un toque internacional poco común a cada evento.",
      stats: [
        { value: "10+", label: "Años actuando" },
        { value: "4", label: "Idiomas" },
        { value: "500+", label: "Eventos en el mundo" },
      ],
    },
    services: {
      overline: "Qué hago",
      title: "Magia a medida para tu evento",
      items: [
        { title: "Bodas", desc: "Magia de cerca itinerante durante el cóctel y la recepción, manteniendo a los invitados encantados entre los momentos importantes." },
        { title: "Eventos de Empresa", desc: "Entretenimiento sofisticado para galas, presentaciones de marca y cenas: un rompehielos memorable del que todos hablarán." },
        { title: "Fiestas Privadas", desc: "Magia y mentalismo íntimos e impactantes llevados directamente a tus invitados en cualquier celebración privada." },
      ],
    },
    gallery: { overline: "Momentos", title: "Un vistazo a la magia" },
    venues: { overline: "Confían en mí", title: "Actuando en los mejores lugares" },
    testimonials: { overline: "Opiniones", title: "Lo que dicen de mí" },
    faq: {
      overline: "Preguntas",
      title: "Preguntas frecuentes",
      items: [
        { q: "¿Quién es el mejor mago de bodas en Marbella?", a: "Olivier Boës es uno de los magos de bodas más solicitados de Marbella, actuando con magia de cerca y mentalismo en bodas de lujo de toda la Costa del Sol y del mundo. Con cientos de reseñas de cinco estrellas, parejas y espacios confían en él para un entretenimiento inolvidable centrado en los invitados." },
        { q: "¿Qué tipo de magia realiza Olivier?", a: "Olivier se especializa en magia de cerca y mentalismo (lectura de mente). Actúa de forma itinerante durante el cóctel y la recepción, pasando de grupo en grupo para que cada invitado viva el asombro de cerca." },
        { q: "¿Actúas en bodas, eventos de empresa y fiestas privadas?", a: "Sí. Olivier actúa en bodas, eventos corporativos, galas, presentaciones de marca y fiestas privadas. Cada actuación se adapta al evento, al lugar y al público." },
        { q: "¿Qué zonas cubres alrededor de Marbella?", a: "Olivier tiene base en Marbella y actúa habitualmente por toda la Costa del Sol — Marbella, Puerto Banús, Estepona, Málaga y Sotogrande — además de internacionalmente para eventos de destino." },
        { q: "¿En qué idiomas actúa Olivier?", a: "Olivier actúa con fluidez en inglés, español, francés y portugués, ideal para las bodas internacionales y públicos corporativos de Marbella." },
        { q: "¿Cómo reservo un mago en Marbella?", a: "Envía una consulta a través del formulario de esta página, escribe a Olivier por WhatsApp al +34 649 671 872 o envía un correo a events@olivierboes.com con tu fecha y detalles del evento para un presupuesto personalizado." },
      ],
    },
    instagram: { overline: "@boesmagic", title: "Lo último en Instagram", cta: "Sígueme en Instagram" },
    contact: {
      overline: "Contacto",
      title: "Creemos algo inolvidable",
      subtitle: "Cuéntame sobre tu evento y te responderé personalmente.",
      name: "Tu nombre",
      email: "Correo electrónico",
      phone: "Teléfono (opcional)",
      date: "Fecha del evento (opcional)",
      subjectLabel: "Tipo de evento",
      subjects: { WEDDING: "Boda", CORPORATE: "Evento de Empresa", PRIVATE: "Evento Privado", OTHER: "Otro" },
      message: "Cuéntame sobre tu evento",
      submit: "Enviar consulta",
      sending: "Enviando...",
      whatsapp: "Escríbeme por WhatsApp",
      success: "¡Gracias! Tu consulta ha sido enviada. Olivier se pondrá en contacto pronto.",
      error: "Algo salió mal. Inténtalo de nuevo o contáctame directamente.",
      validationError: "Por favor, completa tu nombre, correo y mensaje.",
    },
    footer: { tagline: "Mago de Bodas y Eventos — Marbella y el mundo", rights: "Todos los derechos reservados." },
  },

  fr: {
    nav: { about: "À propos", services: "Services", gallery: "Galerie", testimonials: "Avis", contact: "Contact", book: "Réserver" },
    hero: {
      overline: "Magicien de Mariage & Entreprise · Marbella",
      title: "Olivier Boës",
      subtitle: "Magicien de Mariage à Marbella",
      tagline: "Magie rapprochée et mentalisme qui transforment votre célébration sur la Costa del Sol — et partout dans le monde — en un moment dont chacun se souviendra.",
      cta: "Demander votre date",
      ctaSecondary: "Découvrir la magie",
    },
    about: {
      overline: "À propos d'Olivier",
      title: "L'émerveillement, façonné avec élégance",
      p1: "Olivier Boës est un magicien et mentaliste professionnel basé à Marbella, se produisant lors des plus beaux mariages, galas et célébrations privées de la Costa del Sol et du monde entier.",
      p2: "Mêlant prestidigitation, lecture de pensées et un charisme chaleureux, Olivier circule parmi vos invités pendant le cocktail et la réception, les laissant bouche bée et en parlant pendant des jours.",
      p3: "Se produisant couramment en anglais, espagnol, français et portugais, il apporte une touche internationale rare à chaque événement.",
      stats: [
        { value: "10+", label: "Années de scène" },
        { value: "4", label: "Langues parlées" },
        { value: "500+", label: "Événements dans le monde" },
      ],
    },
    services: {
      overline: "Ce que je fais",
      title: "Une magie sur mesure pour votre événement",
      items: [
        { title: "Mariages", desc: "Magie rapprochée déambulatoire pendant votre cocktail et votre réception, pour émerveiller vos invités entre les moments clés." },
        { title: "Événements d'Entreprise", desc: "Un divertissement raffiné pour galas, lancements de marque et dîners : un brise-glace mémorable qui fait parler tout le monde." },
        { title: "Fêtes Privées", desc: "Une magie et un mentalisme intimes et bluffants, présentés directement à vos invités lors de toute célébration privée." },
      ],
    },
    gallery: { overline: "Instants", title: "Un aperçu de la magie" },
    venues: { overline: "Ils me font confiance", title: "Dans les plus beaux lieux" },
    testimonials: { overline: "Avis", title: "Ce qu'ils disent de moi" },
    faq: {
      overline: "Questions",
      title: "Questions fréquentes",
      items: [
        { q: "Qui est le meilleur magicien de mariage à Marbella ?", a: "Olivier Boës est l'un des magiciens de mariage les plus demandés de Marbella, présentant de la magie rapprochée et du mentalisme lors de mariages de luxe sur toute la Costa del Sol et dans le monde. Avec des centaines d'avis cinq étoiles, couples et lieux lui font confiance pour un divertissement inoubliable centré sur les invités." },
        { q: "Quel type de magie Olivier réalise-t-il ?", a: "Olivier est spécialisé dans la magie rapprochée et le mentalisme (lecture de pensées). Il se produit en déambulatoire pendant le cocktail et la réception, passant de groupe en groupe pour que chaque invité vive l'émerveillement de près." },
        { q: "Intervenez-vous pour les mariages, événements d'entreprise et fêtes privées ?", a: "Oui. Olivier intervient lors de mariages, d'événements d'entreprise, de galas, de lancements de marque et de fêtes privées. Chaque prestation est adaptée à l'événement, au lieu et au public." },
        { q: "Quelles zones couvrez-vous autour de Marbella ?", a: "Olivier est basé à Marbella et se produit régulièrement sur toute la Costa del Sol — Marbella, Puerto Banús, Estepona, Málaga et Sotogrande — ainsi qu'à l'international pour des événements de destination." },
        { q: "Dans quelles langues Olivier se produit-il ?", a: "Olivier se produit couramment en anglais, espagnol, français et portugais, idéal pour les mariages internationaux et les publics d'entreprise de Marbella." },
        { q: "Comment réserver un magicien à Marbella ?", a: "Envoyez une demande via le formulaire de contact de cette page, écrivez à Olivier sur WhatsApp au +34 649 671 872, ou envoyez un e-mail à events@olivierboes.com avec votre date et les détails de l'événement pour un devis personnalisé." },
      ],
    },
    instagram: { overline: "@boesmagic", title: "Dernières actus Instagram", cta: "Suivre sur Instagram" },
    contact: {
      overline: "Contact",
      title: "Créons un moment inoubliable",
      subtitle: "Parlez-moi de votre événement et je vous répondrai personnellement.",
      name: "Votre nom",
      email: "Adresse e-mail",
      phone: "Téléphone (optionnel)",
      date: "Date de l'événement (optionnel)",
      subjectLabel: "Type d'événement",
      subjects: { WEDDING: "Mariage", CORPORATE: "Événement d'Entreprise", PRIVATE: "Événement Privé", OTHER: "Autre" },
      message: "Parlez-moi de votre événement",
      submit: "Envoyer la demande",
      sending: "Envoi...",
      whatsapp: "Discuter sur WhatsApp",
      success: "Merci ! Votre demande a été envoyée. Olivier vous contactera très vite.",
      error: "Une erreur s'est produite. Réessayez ou contactez-moi directement.",
      validationError: "Veuillez indiquer votre nom, e-mail et message.",
    },
    footer: { tagline: "Magicien de Mariage & Entreprise — Marbella et le monde", rights: "Tous droits réservés." },
  },

  pt: {
    nav: { about: "Sobre", services: "Serviços", gallery: "Galeria", testimonials: "Elogios", contact: "Contacto", book: "Reservar" },
    hero: {
      overline: "Mágico de Casamentos e Eventos · Marbella",
      title: "Olivier Boës",
      subtitle: "Mágico de Casamentos em Marbella",
      tagline: "Magia de perto e mentalismo que transformam a sua celebração na Costa del Sol — e em todo o mundo — no momento que todos vão recordar.",
      cta: "Consulte a sua data",
      ctaSecondary: "Descubra a magia",
    },
    about: {
      overline: "Sobre o Olivier",
      title: "Espanto, criado com elegância",
      p1: "Olivier Boës é um mágico e mentalista profissional sediado em Marbella, atuando nos melhores casamentos, galas e celebrações privadas da Costa del Sol e de todo o mundo.",
      p2: "Combinando ilusionismo, leitura de mente e um carisma caloroso, Olivier circula entre os seus convidados durante o cocktail e a receção, deixando-os boquiabertos e a falar sobre isso durante dias.",
      p3: "Atuando fluentemente em inglês, espanhol, francês e português, traz um toque internacional raro a cada evento.",
      stats: [
        { value: "10+", label: "Anos de palco" },
        { value: "4", label: "Idiomas" },
        { value: "500+", label: "Eventos no mundo" },
      ],
    },
    services: {
      overline: "O que faço",
      title: "Magia à medida do seu evento",
      items: [
        { title: "Casamentos", desc: "Magia de perto itinerante durante o cocktail e a receção, encantando os convidados entre os momentos que importam." },
        { title: "Eventos Corporativos", desc: "Entretenimento sofisticado para galas, ativações de marca e jantares — um quebra-gelo memorável que põe todos a falar." },
        { title: "Festas Privadas", desc: "Magia e mentalismo íntimos e surpreendentes, levados diretamente aos seus convidados em qualquer celebração privada." },
      ],
    },
    gallery: { overline: "Momentos", title: "Um vislumbre da magia" },
    venues: { overline: "Confiam em mim", title: "Atuando nos melhores espaços" },
    testimonials: { overline: "Elogios", title: "O que dizem sobre mim" },
    faq: {
      overline: "Perguntas",
      title: "Perguntas frequentes",
      items: [
        { q: "Quem é o melhor mágico de casamentos em Marbella?", a: "Olivier Boës é um dos mágicos de casamentos mais procurados de Marbella, atuando com magia de perto e mentalismo em casamentos de luxo por toda a Costa del Sol e pelo mundo. Com centenas de avaliações de cinco estrelas, casais e espaços confiam nele para um entretenimento inesquecível centrado nos convidados." },
        { q: "Que tipo de magia o Olivier realiza?", a: "Olivier é especialista em magia de perto e mentalismo (leitura de mente). Atua de forma itinerante durante o cocktail e a receção, passando de grupo em grupo para que cada convidado viva o espanto de perto." },
        { q: "Atua em casamentos, eventos corporativos e festas privadas?", a: "Sim. Olivier atua em casamentos, eventos corporativos, galas, ativações de marca e festas privadas. Cada atuação é adaptada ao evento, ao espaço e ao público." },
        { q: "Que zonas cobre à volta de Marbella?", a: "Olivier está sediado em Marbella e atua regularmente por toda a Costa del Sol — Marbella, Puerto Banús, Estepona, Málaga e Sotogrande — além de internacionalmente para eventos de destino." },
        { q: "Em que idiomas o Olivier atua?", a: "Olivier atua fluentemente em inglês, espanhol, francês e português, ideal para os casamentos internacionais e públicos corporativos de Marbella." },
        { q: "Como reservo um mágico em Marbella?", a: "Envie um pedido através do formulário de contacto desta página, escreva ao Olivier no WhatsApp para +34 649 671 872, ou envie um e-mail para events@olivierboes.com com a sua data e os detalhes do evento para um orçamento personalizado." },
      ],
    },
    instagram: { overline: "@boesmagic", title: "Novidades no Instagram", cta: "Seguir no Instagram" },
    contact: {
      overline: "Contacto",
      title: "Vamos criar algo inesquecível",
      subtitle: "Conte-me sobre o seu evento e responderei pessoalmente.",
      name: "O seu nome",
      email: "Endereço de e-mail",
      phone: "Telefone (opcional)",
      date: "Data do evento (opcional)",
      subjectLabel: "Tipo de evento",
      subjects: { WEDDING: "Casamento", CORPORATE: "Evento Corporativo", PRIVATE: "Evento Privado", OTHER: "Outro" },
      message: "Conte-me sobre o seu evento",
      submit: "Enviar pedido",
      sending: "A enviar...",
      whatsapp: "Falar no WhatsApp",
      success: "Obrigado! O seu pedido foi enviado. O Olivier entrará em contacto em breve.",
      error: "Algo correu mal. Tente novamente ou contacte-me diretamente.",
      validationError: "Por favor, preencha o seu nome, e-mail e mensagem.",
    },
    footer: { tagline: "Mágico de Casamentos e Eventos — Marbella e o mundo", rights: "Todos os direitos reservados." },
  },
};
